import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { InscricaoCabecaChaveDto } from '@models/clash/clash-dto';
import { ClashFilter, ClashForm } from '@models/clash/clash-form.dto';
import { ClashDto } from '@models/embate/clash-dto';
import { IResponseDto } from '@models/exceptions/response-dto';
import { IPage } from '@models/pagination/page';
import { IPageable } from '@models/pagination/pageable';
import { extractResponse } from '@shared/rxjs/custom-rxjs-operators';
import { Observable } from 'rxjs';
import { toParams } from '../../../utilities/utility-functions';
import { BaseService } from '../base-service';

@Injectable({
  providedIn: 'root',
})
export class ClashService extends BaseService {
  
  private url: string = environment.apiUrl + '/v1/chaves-embate';

  getClash(cheNrId?: number): Observable<ClashDto> {
    return this.http
      .get<IResponseDto<ClashDto>>(`${this.url}/${cheNrId}`)
      .pipe(extractResponse());
  }

  editClash(clashForm: ClashForm): Observable<void> {
    //TODO: Colocar em outro service para /v1/embate
    return this.http
      .put<IResponseDto<void>>(environment.apiUrl + '/v1/embates', clashForm)
      .pipe(extractResponse());
  }

  configureClash(
    params: IConfigureClashParams
  ): Observable<void> {
    const { cheTxNome, cheNrId, petNrId } = params
    return this.http
      .put<
        IResponseDto<void>
      >(`${this.url}/${cheNrId}/atualizar-chave/parametrizacao/${petNrId}`, {cheTxNome})
      .pipe(extractResponse());
  }
  getParticipants(
    cheNrId?: number,
    incTxResumo?: string,
    pageable?: IPageable,
  ): Observable<IPage<InscricaoCabecaChaveDto>> {
    let params = toParams({ incTxResumo: incTxResumo, pageable: pageable });
    return this.http
      .get<
        IResponseDto<IPage<InscricaoCabecaChaveDto>>
      >(this.url + '/' + cheNrId + '/inscricoes', { params: params })
      .pipe(extractResponse());
  }

  getClashs(
    clashFilter: ClashFilter,
    pageable: IPageable,
  ): Observable<IPage<ClashDto>> {
    let params = toParams(clashFilter, pageable);
    return this.http
      .get<IResponseDto<IPage<ClashDto>>>(`${this.url}`, { params: params })
      .pipe(extractResponse());
  }
}
interface IConfigureClashParams {
  cheTxNome: string;
  cheNrId: number;
  petNrId: number;
}
